/* eslint-disable react/no-children-prop */
import * as React from 'react';
import { FormSpy as RffFormSpy } from 'react-final-form';
import { FormState, FormSubscription, RenderableProps } from './FinalFormTypes';
import { FormApi } from 'final-form';

export interface FormSpyRenderProps<FormValues = Record<string, unknown>, InitialFormValues = Partial<FormValues>>
   extends FormState<FormValues, InitialFormValues> {
   form: FormApi<FormValues, InitialFormValues>;
}

export interface UseFormStateParams<FormValues = Record<string, unknown>, InitialFormValues = Partial<FormValues>> {
   onChange?: (formState: FormState<FormValues, InitialFormValues>) => void;
   subscription?: FormSubscription;
}

export interface FormSpyProps<FormValues = Record<string, unknown>, InitialFormValues = Partial<FormValues>>
   extends UseFormStateParams<FormValues, InitialFormValues>,
           RenderableProps<FormSpyRenderProps<FormValues, InitialFormValues>> {}

export const FormSpy = (props: FormSpyProps) => {
   return (
      <RffFormSpy
         onChange={props.onChange}
         subscription={props.subscription}
         render={props.render}
         component={props.component}
         children={props.children}
      />
   );
};
